// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3RsMv","calendarButtons":"ClockData_calendarButtons__jiZzP"};